(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-components/assets/javascripts/match-analysis.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-components/assets/javascripts/match-analysis.js');
"use strict";


const {
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  useAuthorProfilePicture,
  useAnalysisOutcomes
} = svs.components.sportinfo.gameAnalysesRedux.hooks;
const {
  selectMatchAnalysis,
  selectAuthorProfile
} = svs.components.sportinfo.gameAnalysesRedux.selectors;
const {
  productIds
} = svs.utils.products;
const {
  getOutcomeLabelsForEventType
} = svs.components.sport.tipsenShared;
const {
  OutcomePair
} = svs.components.lbUi;
const TARGET_PROFILE_IMAGE_SIZE = 44;
const isSelected = (outcomes, sign) => outcomes.some(outcome => outcome.outcomeNumber === sign.toString());
const Outcome1X2 = _ref => {
  let {
    matchAnalysis,
    branding,
    eventTypeId,
    sportType
  } = _ref;
  const outcomes = useAnalysisOutcomes(matchAnalysis)[0];
  const labels = getOutcomeLabelsForEventType(eventTypeId, sportType);
  return React.createElement("div", {
    className: "analysis-bet-buttons"
  }, labels.map(outcome => React.createElement("div", {
    className: "btn-bet btn-bet-300 btn-bet-".concat(branding, " ").concat(isSelected(outcomes, outcome.sign) ? ' btn-bet-selected' : ''),
    key: outcome.text
  }, React.createElement("span", {
    className: "btn-bet-label"
  }, outcome.text))));
};
const OutcomeFulltraff = _ref2 => {
  let {
    matchAnalysis
  } = _ref2;
  const outcomes = useAnalysisOutcomes(matchAnalysis)[0];
  const outComesGoalCountDisplay = "".concat(outcomes.map(outcome => outcome.description).join(', '), " m\xE5l");
  return React.createElement("span", {
    className: "analysis-outcomes-fulltraff f-600 f-bold fc-navy"
  }, outComesGoalCountDisplay);
};
const OutcomeBomben = _ref3 => {
  var _allHomeScoreValues$, _allAwayScoreValues$;
  let {
    matchAnalysis
  } = _ref3;
  const outcomes = useAnalysisOutcomes(matchAnalysis);
  const allHomeScoreValues = outcomes[0];
  const allAwayScoreValues = outcomes[1];
  const homeScore = (_allHomeScoreValues$ = allHomeScoreValues[0]) === null || _allHomeScoreValues$ === void 0 ? void 0 : _allHomeScoreValues$.description;
  const awayScore = (_allAwayScoreValues$ = allAwayScoreValues[0]) === null || _allAwayScoreValues$ === void 0 ? void 0 : _allAwayScoreValues$.description;
  if (!homeScore || !awayScore) {
    return null;
  }
  return React.createElement("div", {
    className: "bomben-game-analysis-item-prediction"
  }, React.createElement(OutcomePair, {
    outcomeAway: awayScore,
    outcomeHome: homeScore
  }));
};
const MatchAnalysis = _ref4 => {
  let {
    analysisId,
    branding,
    theme,
    eventTypeId = 1,
    sportType = 1
  } = _ref4;
  const matchAnalysis = useSelector(state => selectMatchAnalysis(state, analysisId));
  const authorProfile = useSelector(state => selectAuthorProfile(state, matchAnalysis.authorId));
  const profileImage = useAuthorProfilePicture(authorProfile, TARGET_PROFILE_IMAGE_SIZE);
  const productId = useMemo(() => matchAnalysis.gameInfo.products[0], [matchAnalysis]);
  let OutcomeComponent;
  switch (Number(productId)) {
    case productIds.BOMBEN:
      OutcomeComponent = OutcomeBomben;
      break;
    case productIds.CHALLENGE:
      OutcomeComponent = null;
      break;
    case productIds.HVS:
      OutcomeComponent = OutcomeFulltraff;
      break;
    default:
      OutcomeComponent = Outcome1X2;
      break;
  }
  return React.createElement("div", {
    className: "match-info-match-analysis"
  }, React.createElement("div", {
    className: "analysis-header margin-bottom-2"
  }, profileImage && React.createElement("img", {
    alt: "Profil av ".concat(authorProfile.authorLongName),
    className: "analysis-profile-picture",
    src: profileImage,
    style: {
      width: TARGET_PROFILE_IMAGE_SIZE,
      height: TARGET_PROFILE_IMAGE_SIZE
    }
  }), React.createElement("span", {
    className: "analysis-author-name f-600 f-bold ".concat(theme === 'DARK' ? 'fc-white' : 'fc-navy')
  }, authorProfile.authorLongName), OutcomeComponent && React.createElement(OutcomeComponent, {
    branding: branding,
    eventTypeId: eventTypeId,
    matchAnalysis: matchAnalysis,
    sportType: sportType,
    theme: theme
  })), React.createElement("div", {
    className: "analysis-body ".concat(theme ? theme.toLowerCase() : ''),
    dangerouslySetInnerHTML: {
      __html: matchAnalysis.body
    }
  }));
};
setGlobal('svs.components.sportinfo.matchInfoComponents.MatchAnalysis', MatchAnalysis);

 })(window);